import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'

export const FormFieldValidationSchema = buildEntrySchemaFor('formFieldValidation', {
  fields: z.lazy(() =>
    z.object({
      name: z.enum(['REQUIRED', 'WORK_EMAIL_ONLY', 'EMAIL', 'PHONE']),
    }),
  ),
})

export type FormFieldValidation = z.infer<typeof FormFieldValidationSchema>
